import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import dayjs from 'dayjs';

export interface RapportASignerState {
    rapports: InterventionNonPreventive[];

    tableHeader: TableHeader[];

    page: number;
    nbOfPages: number;
    scroll: number;
    count: number;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };

    filterSite: Array<number>;
    filterInterventionId: string;
    filterPredictedDateFrom: string;
    filterPredictedDateTo: string;

    isLoading: boolean;
    error?: Error;
    success: boolean;

    isExportXlsLoading: boolean;
}

export class RechercheRapportDTO {
    chantierIds?: number[];
    page?: number;
    size?: number;
    unpaged?: boolean;
    sort?: string[];

    constructor(chantierIds?: number[], page?: number, size?: number, sort?: string[], unpaged?: boolean) {
        this.page = page;
        this.size = size;
        this.unpaged = unpaged;
        this.sort = sort;
        this.chantierIds = chantierIds || undefined;
    }
}

export const initialState: RapportASignerState = {
    rapports: [],

    tableHeader: [
        {
            label: '',
            sortData: 'idBis',
            sortStatus: SortType.INACTIVE,
            width: '10%',
        },
        {
            label: 'intervention.id',
            sortData: 'id',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'intervention.objet',
            sortData: 'objet',
            sortStatus: SortType.NONE,
            width: '45%',
        },
        {
            label: 'intervention.dateDebutPrevue',
            sortData: 'dateFin',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'intervention.request.pdf',
            sortData: 'etat',
            sortStatus: SortType.INACTIVE,
            width: '10%',
        }
    ],

    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    sort: {
        sortData: 'dateDebutPrevue',
        sortStatus: SortType.DESC,
    },

    filterSite: [],
    filterInterventionId: '',
    filterPredictedDateFrom: dayjs().add(-1,'y' ).format('YYYY-MM-DD'),
    filterPredictedDateTo: dayjs().format('YYYY-MM-DD'),

    isLoading: false,
    success: false,

    isExportXlsLoading: false,
};

export const state: RapportASignerState = {
    ...initialState,
};
